import type { StudentClessonResults } from '@yandex-int/k-common';
import { getStudentCLessonResults } from '@yandex-int/k-common/client/api';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as actions from './actions';
import * as constants from './constants';

export function* studentCLessonResultsSagaWatcher() {
    yield all([takeLatest(constants.GET_STUDENT_CLESSON_RESULT_REQUEST, getStudentCLessonResultsSaga)]);
}

export function* getStudentCLessonResultsSaga(action: ReturnType<typeof actions.getStudentResultRequest>) {
    const { clessonId, studentId } = action;

    try {
        const studentResults: StudentClessonResults = yield call(getStudentCLessonResults, clessonId, studentId);

        const currentAttemptIndex = studentResults.results.length - 1;

        yield put(actions.getStudentResultSuccess(clessonId, studentId, studentResults.results[currentAttemptIndex]));
    } catch (error) {
        yield put(actions.getStudentResultError());

        console.error(error);
    }
}
